import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Headers from "./Headers";
import Sidebar from "./Sidebar";

export default function Layout() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div className="h-screen w-full flex overflow-hidden bg-slate-50">
      
      {/* Sidebar */}
      <Sidebar />

      {/* Right Side */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        
        {/* Header */}
        <Headers />

        {/* Main Content Scroll Only */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>

      </div>
    </div>
  );
}